
import React from 'react';
import { Settings } from 'lucide-react';

interface AdminHeaderProps {
  onRestoreDefaults?: () => void;
}

const AdminHeader: React.FC<AdminHeaderProps> = () => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
          <Settings className="h-8 w-8" />
          Admin Panel
        </h1>
        <p className="text-muted-foreground mt-1">
          Manage users and view error logs
        </p>
      </div>
    </div>
  );
};

export default AdminHeader;
